{
  "overview": {},
  "nodes": {},
  "resources": {},
  "fenceDevices": {},
  "sbd": {},
  "constraints": {},
  "properties": {},
  "acl": {},
  "permissions": {}
}
